import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import { get } from "src/api";

/**
 * Fetches all video tutorial URLs in a single request.
 * Returns a map of slug → url (or null).
 */
export const useVideoTutorials = () => {
  const { locale } = useIntl();

  return useQuery<Record<string, string | null>>(
    ["videoTutorialMap", locale],
    () => get<Record<string, string | null>>("/video-tutorial/map", locale),
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );
};
